import { appColors } from './colors';

export const REFRESH = 'refresh';
export const ACCESS = 'access';
export const IS_CORPA_IMPERSONATION = 'is_corpa_impersonation';
export const DEFAULT_MESSAGE_DURATION = 60;
export const orchestratorStatus = {
  provisioning: 'PROVISIONING',
  running: 'RUNNING',
  done: 'SUCCESSFULLY DONE',
  error: 'ERROR!',
};
export const orchestratorStatusProps = status => {
  switch (status) {
    case orchestratorStatus.done:
      return {
        strokeColor: appColors.success,
        status: 'success',
      };
    case orchestratorStatus.error:
      return {
        strokeColor: appColors.danger,
        status: 'error',
      };
    default:
      return {
        strokeColor: appColors.info,
        status: 'active',
      };
  }
};

export const CUBOH_TAGS = {
  ACCEPTING: 'accepting',
  PAUSED: 'paused',
  NEW: 'new',
  PICKUP_ONLY: 'pickup-only',
  FAILED_UPDATE: 'unavailable',
  UNSUPPORTED: 'unsupported',
  MASTER_MENU: 'master',
  MASTER_ITEM: 'master_item',
  LINKED_MENU: 'linked_menu',
  PUBLISHED: 'published',
  IMPORT_IN_PROGRESS: 'import_in_progress',
  FAILED: 'failed',
  IN_PROGRESS: 'in_progress',
  MODIFIED: 'modified',
  INACTIVE: 'inactive',
  IMPORT_SOURCE: 'import_source',
  ERROR: 'error',
  SHARED_ITEM: 'shared',
  STORE_CLOSED: 'store_closed',
  STORE_OPEN: 'store_open',
  DISABLED: 'disabled',
};

export const CUBOH_INTEGRATION_STATUS = {
  failed: 'failed',
  inactive: 'inactive',
  inProgress: 'in_progress',
  modified: 'modified',
  published: 'published',
  pulled: 'pulled',
};

export const CUBOH_ORDER_STATUS = {
  COMPLETED: 1,
  IN_PROGRESS: 2,
  ACTIVE: 3,
  CANCELLED: 4,
  SCHEDULED: 5,
  INACTIVE: 6,
};

export const ACTIVE = 'Accepted';
export const IN_PROGRESS = 'In-progress';
export const COMPLETED = 'Ready';
export const INACTIVE = 'Inactive';
export const SCHEDULED = 'Scheduled';
export const CANCELLED = 'Canceled';

// normalized order status keys for internal UI logic (StatusTag)
export const ORDER_STATUS_KEYS = {
  ACTIVE: 'active',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  SCHEDULED: 'scheduled',
  INACTIVE: 'inactive',
  CANCELED: 'cancelled', // cuboh still returns "cancelled" but we display "canceled"
};

export const ORDER_STATUS_SCHEDULED_TEXT = 'Accepted (Scheduled)';

export const COMPANY_ID = 'companyID';
export const MERCHANT_ID = 'merchantID';

export const IMAGE_CONTENT_REQUEST_TYPE = 'image/jpeg';

export const CUBOH_SUPPORT_EMAIL = 'support@cuboh.com';

// Timeout for Core API requests to prevent indefinite hangs
export const CORE_API_TIMEOUT_MS = 5000;
